var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"type":"checkbox"},on:{"input":function($event){return _vm.$emit('input')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }